import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'

const STORAGE_KEY = 'paymentReturnMarks'
const RETURN_MARK_TTL_MS = 86400000

type PaymentReturnMarks = Record<string, number>

const getMarkKey = (
  platform: CampaignPlatformTypeEnum,
  campaignId: number,
): string => `${platform}:${campaignId}`

const readMarks = (): PaymentReturnMarks => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? (JSON.parse(raw) as PaymentReturnMarks) : {}
  } catch {
    return {}
  }
}

export const markReturnedFromPaymentProvider = (
  platform: CampaignPlatformTypeEnum,
  campaignId: number,
  now = Date.now(),
): boolean => {
  try {
    const marks = readMarks()
    marks[getMarkKey(platform, campaignId)] = now
    localStorage.setItem(STORAGE_KEY, JSON.stringify(marks))
    return true
  } catch {
    return false
  }
}

export const hasRecentPaymentReturn = (
  platform: CampaignPlatformTypeEnum,
  campaignId: number,
  now = Date.now(),
): boolean => {
  const returnedAt = readMarks()[getMarkKey(platform, campaignId)]
  return returnedAt !== void 0 && now - returnedAt < RETURN_MARK_TTL_MS
}
